import { render, staticRenderFns } from "./SingleSectionCloseBtn.vue?vue&type=template&id=32d25e98&scoped=true&"
import script from "./SingleSectionCloseBtn.vue?vue&type=script&lang=js&"
export * from "./SingleSectionCloseBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d25e98",
  null
  
)

export default component.exports